// Free, confidential lines. Numbers are from memory (2026-10-27, no live check was possible); to be verified against each organisation's site before launch.
export const HELPLINES: Record<"en" | "he" | "de", { name: string; phone: string; url?: string }[]> = {
  en: [
    { name: "988 Suicide & Crisis Lifeline (US)", phone: "988", url: "https://988lifeline.org" },
    { name: "Samaritans (UK & Ireland)", phone: "116 123", url: "https://www.samaritans.org" },
    { name: "Find a helpline in your country", phone: "", url: "https://findahelpline.com" },
  ],
  he: [
    { name: "ער״ן — עזרה ראשונה נפשית", phone: "1201", url: "https://www.eran.org.il" },
    { name: "סה״ר — סיוע והקשבה ברשת", phone: "", url: "https://sahar.org.il" },
  ],
  de: [
    { name: "TelefonSeelsorge", phone: "0800 111 0 111", url: "https://www.telefonseelsorge.de" },
    { name: "TelefonSeelsorge", phone: "0800 111 0 222" },
  ],
};
